import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const HighRiseBuildingIcon = createIcon({
  displayName: 'HighRiseBuildingIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M8 21v-17l1.06581e-14 1.50996e-07c-8.33927e-08-.552285.447715-1 1-1h6l-4.37114e-08 8.88178e-16c.552285-2.41411e-08 1 .447715 1 1v17"></path>
        <path d="M21 21v-13.087h3.55271e-15c0-.504236-.408764-.913-.913-.913 0 0 0 0 0 0h-4.087"></path>
        <path d="M8 7h-4.087l-3.99085e-08 8.88178e-16c-.504236 2.20409e-08-.913.408764-.913.913 0 0 0 8.88178e-16 0 8.88178e-16v13.087"></path>
        <line x1="16" x2="18.5" y1="10" y2="10"></line>
        <line x1="16" x2="18.5" y1="13" y2="13"></line>
        <line x1="16" x2="18.5" y1="16" y2="16"></line>
        <line x1="5.5" x2="8" y1="10" y2="10"></line>
        <line x1="5.5" x2="8" y1="13" y2="13"></line>
        <line x1="5.5" x2="8" y1="16" y2="16"></line>
        <line x1="10.5" x2="13.5" y1="13" y2="13"></line>
        <line x1="10.5" x2="13.5" y1="16" y2="16"></line>
        <line x1="10.5" x2="13.5" y1="10" y2="10"></line>
        <line x1="10.5" x2="13.5" y1="7" y2="7"></line>
        <line x1="12" x2="12" y1="19" y2="21"></line>
        <line x1="22" x2="2" y1="21" y2="21"></line>
      </g>
      <rect width="24" height="24" fill="none"></rect>
    </>
  ),
})

const HighRiseBuilding: FC<IconProps> = (props) => {
  return <CustomIcon as={HighRiseBuildingIcon} {...props} />
}

export default memo(HighRiseBuilding)
